import {
  Info,
  UserPlus,
  Download,
  MessageSquare,
  AlertTriangle,
  Star,
  Bell,
} from 'lucide-react';

interface NotificationIconProps {
  type: string;
  className?: string;
}

export default function NotificationIcon({ type, className }: NotificationIconProps) {
  const props = { className: className ?? 'h-5 w-5' };

  switch (type) {
    case 'system':
      return <Info {...props} />;
    case 'project_invite':
    case 'org_join_request_result':
      return <UserPlus {...props} />;
    case 'export_ready':
      return <Download {...props} />;
    case 'boq_comment':
    case 'boq_comment_reply':
      return <MessageSquare {...props} />;
    case 'trial_expiring':
      return <AlertTriangle {...props} />;
    case 'subscription_upgraded':
      return <Star {...props} />;
    default:
      return <Bell {...props} />;
  }
}
